import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Action, getModule, Mutation } from "vuex-module-decorators";
import store from "../../store";
import service from "../../services/api.service";
import { getTenantId } from "@/store/helper";
import { GuidItemModel } from "../models/shared/guidItem";
import { CyclesListingModel } from "../models/cycle/cycle";
import { plainToClass } from "class-transformer";
import { PACycleRequestModel } from "../models/cycle/paCycleRequestDTO";
import { ICycleSearchData } from "../models/cycle/cycleSearchData";
import { IPACycleSaveDTO } from "../models/cycle/paCycleSaveDTO";
import { PACycleLegendsModel } from "../models/cycle/paCycleLegendsDTO";
let CyclesModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    let CyclesModule = class CyclesModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "PACycle";
            this.cycles = [];
            this.yearList = [];
            this.teams = [];
            this.totalCount = 0;
            this.pMOteams = [];
            this.PACycleEmployeesModel = [];
            this.workFlows = [];
            this.employeesWorkFlow = [];
            this.cycleOverView = null;
            this.gridParams = null;
            this.legends = [];
            this.isDuplicateCycleName = false;
            this.paCycleReviewsStatus = [];
        }
        async GetCycles(searchData) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, searchData);
            if (data) {
                this.setCycles(plainToClass(CyclesListingModel, data.cycles));
                this.setTeams(plainToClass(GuidItemModel, data.teams));
                this.setyearList(plainToClass(GuidItemModel, data.yearList));
                this.setTotalCount(plainToClass(GuidItemModel, data.totalCount));
                this.setLegends(plainToClass(PACycleLegendsModel, data.legends));
                return data;
            }
        }
        async GetTeamList() {
            var url = `${getTenantId()}/${this.apiNode}/team`;
            let { data } = await service.get(url);
            if (data) {
                this.setPMOTeams(data.teams);
                return data;
            }
        }
        async GetWorkFlow(teamId) {
            var url = `${getTenantId()}/${this.apiNode}/workFlow/` + teamId;
            let { data } = await service.get(url);
            if (data) {
                this.SetWorkFlow(plainToClass(GuidItemModel, data.workFlows));
                this.SetemployeeWorkflow(data.employeesWorkFlow);
                return data;
            }
        }
        async CreatePaCycles(paCycle) {
            var url = `${getTenantId()}/${this.apiNode}/save`;
            let { data } = await service.post(url, paCycle);
            if (data) {
                return data;
            }
        }
        async GetCycleOverView(cycleId) {
            var url = `${getTenantId()}/${this.apiNode}/overView/` + "" + cycleId;
            let { data } = await service.get(url);
            if (data) {
                this.SetCycleOverView(data.reviewOverview);
                return data;
            }
        }
        async UpdateAutoNudge(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/updateAutoNudge?cycleId=${payLoad.cycleId}&enableAutoNudge=${payLoad.enableAutoNudge}`;
            let { data } = await service.put(url);
            if (data) {
                this.SetAutoNudge(payLoad.enableAutoNudge);
                return data;
            }
        }
        async DeleteCycle(cycleId) {
            var url = `${getTenantId()}/${this.apiNode}/delete/${cycleId}`;
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        async GettingCyceReviewsStatus(cycleId) {
            var url = `${getTenantId()}/${this.apiNode}/reviewsStatus/${cycleId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetCycleReviewsStatus(plainToClass(GuidItemModel, data.paCycleReviewsStatus));
                return data;
            }
        }
        async CheckForDuplicateCycleName(cycleName) {
            var url = `${getTenantId()}/${this.apiNode}/validateCycleName`;
            let { data } = await service.post(url, { cycleName: cycleName });
            if (data) {
                this.setIsDuplicateCycleName(data);
                return data;
            }
        }
        SetCycleReviewsStatus(paCycleReviewsStatus) {
            this.paCycleReviewsStatus = paCycleReviewsStatus;
        }
        SetAutoNudge(nudge) {
            this.cycleOverView.autoNudge = nudge;
        }
        setIsDuplicateCycleName(data) {
            this.isDuplicateCycleName = data.isDuplicate;
        }
        SetCycleOverView(reviewOverview) {
            this.cycleOverView = reviewOverview;
        }
        DeleteEmployeeFromCycleReview(id) {
            this.employeesWorkFlow = this.employeesWorkFlow.filter((x) => x.id != id);
        }
        SetWorkFlow(workFlow) {
            this.workFlows = workFlow;
        }
        SetemployeeWorkflow(employeesWorkFlow) {
            this.employeesWorkFlow = employeesWorkFlow;
        }
        setPMOTeams(teams) {
            this.pMOteams = teams;
        }
        AssignParams(params) {
            this.gridParams = Object.assign({}, params);
        }
        AssignCycleDataParams(params) {
            this.gridParams.cycleFilters = Object.assign({}, params);
        }
        ResetPage() {
            this.gridParams = null;
        }
        setCycles(cycles) {
            this.cycles = cycles;
        }
        setTeams(teams) {
            this.teams = teams;
        }
        setyearList(yearList) {
            this.yearList = yearList;
        }
        setTotalCount(totalCount) {
            this.totalCount = totalCount;
        }
        setLegends(legends) {
            this.legends = legends;
        }
        ClearSummaryStatus() {
            this.paCycleReviewsStatus = null;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof ICycleSearchData !== "undefined" && ICycleSearchData) === "function" ? _a : Object]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], CyclesModule.prototype, "GetCycles", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], CyclesModule.prototype, "GetTeamList", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], CyclesModule.prototype, "GetWorkFlow", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof IPACycleSaveDTO !== "undefined" && IPACycleSaveDTO) === "function" ? _e : Object]),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], CyclesModule.prototype, "CreatePaCycles", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], CyclesModule.prototype, "GetCycleOverView", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
    ], CyclesModule.prototype, "UpdateAutoNudge", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
    ], CyclesModule.prototype, "DeleteCycle", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
    ], CyclesModule.prototype, "GettingCyceReviewsStatus", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_l = typeof Promise !== "undefined" && Promise) === "function" ? _l : Object)
    ], CyclesModule.prototype, "CheckForDuplicateCycleName", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], CyclesModule.prototype, "SetCycleReviewsStatus", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], CyclesModule.prototype, "SetAutoNudge", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], CyclesModule.prototype, "setIsDuplicateCycleName", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], CyclesModule.prototype, "SetCycleOverView", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], CyclesModule.prototype, "DeleteEmployeeFromCycleReview", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], CyclesModule.prototype, "SetWorkFlow", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], CyclesModule.prototype, "SetemployeeWorkflow", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], CyclesModule.prototype, "setPMOTeams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_m = typeof ICycleSearchData !== "undefined" && ICycleSearchData) === "function" ? _m : Object]),
        __metadata("design:returntype", void 0)
    ], CyclesModule.prototype, "AssignParams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_o = typeof PACycleRequestModel !== "undefined" && PACycleRequestModel) === "function" ? _o : Object]),
        __metadata("design:returntype", void 0)
    ], CyclesModule.prototype, "AssignCycleDataParams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CyclesModule.prototype, "ResetPage", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], CyclesModule.prototype, "setCycles", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], CyclesModule.prototype, "setTeams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], CyclesModule.prototype, "setyearList", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], CyclesModule.prototype, "setTotalCount", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], CyclesModule.prototype, "setLegends", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CyclesModule.prototype, "ClearSummaryStatus", null);
    CyclesModule = __decorate([
        Module({ dynamic: true, store: store, name: "Cycle", namespaced: true })
    ], CyclesModule);
    return CyclesModule;
})();
export const CycleModule = getModule(CyclesModule);
